// UAE numbers are 8 digits (landline, e.g. 4 234 5678) or 9 digits (mobile or
// business, e.g. 50 123 4567, 600 123 456) after the 971 code, never starting with 0.
const UAE_LOCAL = /^[1-9]\d{7,8}$/;
const PHONE_CHARS = /^\+?[\d\s\-().]+$/;

// digits must already include the country code
const toInternational = (digits) => {
  if (digits.startsWith("971")) {
    let local = digits.slice(3);
    if (local.startsWith("0")) local = local.slice(1); // +971 050...
    return UAE_LOCAL.test(local) ? `+971${local}` : null;
  }
  if (digits.startsWith("0") || digits.length < 8 || digits.length > 15) return null;
  return `+${digits}`;
};

/**
 * Number typed by the customer, from any country, mobile or business/landline.
 * UAE numbers can be typed locally (050 123 4567, 04 234 5678); numbers from
 * other countries start with + or 00 and their country code.
 * @returns {string|null} +<country code><number>, or null if it isn't valid
 */
export const normalizeTypedPhone = (input) => {
  const raw = String(input || "").trim();
  if (!raw || !PHONE_CHARS.test(raw)) return null;

  const digits = raw.replace(/\D/g, "");
  if (raw.startsWith("+")) return toInternational(digits);
  if (digits.startsWith("00")) return toInternational(digits.slice(2));
  if (digits.startsWith("971")) return toInternational(digits);

  // Local UAE number: 050 123 4567, 04 234 5678, or 50 123 4567 without the 0
  if (digits.startsWith("0")) return UAE_LOCAL.test(digits.slice(1)) ? `+971${digits.slice(1)}` : null;
  return /^5\d{8}$/.test(digits) ? `+971${digits}` : null;
};

/**
 * Number passed in the booking link. It comes from WhatsApp, so it always
 * includes the country code, with or without the +.
 * @returns {string|null}
 */
export const normalizeLinkPhone = (input) => {
  const raw = String(input || "").trim();
  if (!raw || !PHONE_CHARS.test(raw)) return null;
  return toInternational(raw.replace(/\D/g, "").replace(/^00/, ""));
};
